// test722
(722 && 0);
